import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  resetData: () => ({}),
  setState: (state, value) => ({ state, value }),
  getData:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().escalationWorklist.paging;
      let { result, status } = await Api.post(`escalation-worklists/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
        ...sortOption,
      });
      status === 200 && escalationWorklistDispatcher.getDataSuccess(result);
    },
  updateStatusWorklists:
    (paxscreeningId, params, onSuccess) =>
    async ({ Api }) => {
      let { status } = await Api.put(
        `escalation-worklists/${paxscreeningId}/update-status`,
        params
      );
      status === 200 && onSuccess();
    },
};

const escalationWorklistDispatcher = synthesize(
  'escalationWorklist',
  mapDispatchToAC
);
export default escalationWorklistDispatcher;
